document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.contact__form');

  if (form) {
    // Prevenir que Enter envíe el formulario desde inputs
    form.addEventListener('keydown', function (e) {
      const isEnter = e.key === 'Enter' || e.keyCode === 13;
      const isTextField = ['text', 'email', 'tel', 'number', 'password', 'search'].includes(e.target.type);

      if (isEnter && isTextField) {
        e.preventDefault();
      }
    });
  }

  // Filtro para los campos de teléfono
  const phones = document.querySelectorAll('input[type="tel"]');
  phones.forEach(phone => {
    setInputFilter(phone, function (value) {
      return /^\d*(\d*\s?)*\d*$/.test(value); // Solo dígitos y espacios
    }, "Only digits and spaces are allowed");
  });
});

// Filtro de entrada
function setInputFilter(textbox, inputFilter, errMsg) {
  [
    "input", "keydown", "keyup", "mousedown", "mouseup",
    "select", "contextmenu", "drop", "focusout"
  ].forEach(function (event) {
    textbox.addEventListener(event, function (e) {
      if (inputFilter(this.value)) {
        if (["keydown", "mousedown", "focusout"].includes(e.type)) {
          this.classList.remove("input-error");
          this.setCustomValidity("");
        }
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        this.classList.add("input-error");
        this.setCustomValidity(errMsg);
        this.reportValidity();
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      } else {
        this.value = "";
      }
    });
  });
}
